export default "__VITE_ASSET__7cFl9xra__"